import { isNumber, parseDate } from "../../../utils"

export const getCurrentXRange = (axesAndRanges, zoomRanges, timeExtractor, baseTime) => {
  const full_x_range = (axesAndRanges["time"] || []).map((val) => {
    return timeExtractor.name !== "Day"
      ? val
        ? timeExtractor.difference(parseDate(val), baseTime)
        : null
      : isNumber(val)
        ? timeExtractor.difference(val, baseTime)
        : null
  })
  const zoomed_x_range = zoomRanges.time || []
  let xaxisdomain = [
    isNumber(zoomed_x_range[0]) ? zoomed_x_range[0] : full_x_range[0],
    isNumber(zoomed_x_range[1]) ? zoomed_x_range[1] : full_x_range[1],
  ]
  return [
    isNumber(xaxisdomain[0]) ? timeExtractor.offsetDays(baseTime, xaxisdomain[0]) : xaxisdomain[0],
    isNumber(xaxisdomain[1]) ? timeExtractor.offsetDays(baseTime, xaxisdomain[1]) : xaxisdomain[1],
  ]
}
